import { createIcon } from "@chakra-ui/icons";

// Created from upload.svg

export const UploadIcon = createIcon({
  displayName: "Upload",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    color: "brand.analytic",
  },
  path: (
    <g>
      <path
        d="M21 15L21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21L5 21C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19L3 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M17 8L12 3L7 8" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 3L12 15" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </g>
  ),
});
